export default {
  rootCompanyId: null,
  language: null,
  videoNavigationList: []
}
